import { useContext } from "react";
import { RoomTypeContext } from ".";

const useRoomTypeContext = () => useContext(RoomTypeContext);

export default useRoomTypeContext;
